import { useCallback, useState, type ReactNode } from "react";
import Modal from "../components/molecules/Modal";

export function useModal() {
  const [open, setOpen] = useState(false);
  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);

  const ModalContainer = ({ children }: { children: ReactNode }) => (
    <Modal open={open} onClose={closeModal}>
      {children}
    </Modal>
  );

  return { openModal, closeModal, Modal: ModalContainer };
}

export default useModal;
